import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SERVICE_ID_ROUTE_PARAM } from '@core/routes/utils/route-param';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngrx/store';
import { isServiceAuthorized } from '@stores/profile/profile.selectors';
import { NEW_CONSENTS_PROCESS_BLACK_LIST } from '@stores/service-authorization/new-authorization-process-blacklist';
import { updateServiceConfiguration } from '@stores/service-configuration/service-configuration.actions';
import { serviceConfigurationConsentDisplayForm } from '@stores/service-configuration/service-configuration.selectors';
import { combineLatest, map, take } from 'rxjs';

export const displayConsentsPage: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);

  const serviceId = route.paramMap.get(SERVICE_ID_ROUTE_PARAM);
  if (!serviceId) return false;

  if (NEW_CONSENTS_PROCESS_BLACK_LIST.find((item) => item === serviceId)) {
    store.dispatch(updateServiceConfiguration({ serviceId }));

    return combineLatest([
      store.select(serviceConfigurationConsentDisplayForm(serviceId)),
      store.select(isServiceAuthorized(serviceId)),
    ]).pipe(
      take(1),
      map(([serviceRequiresConsents, serviceIsAuthorized]) => {
        if (serviceRequiresConsents && !serviceIsAuthorized) return true;

        return router.parseUrl(
          `${FeaturesRoutingEnum.Redirect}/${serviceId}?contentId=${route.queryParamMap.get('contentId')}`
        );
      })
    );
  } else {
    return combineLatest([
      store.select(serviceConfigurationConsentDisplayForm(serviceId)),
      store.select(isServiceAuthorized(serviceId)),
    ]).pipe(
      take(1),
      map(([serviceRequiresConsents, serviceIsAuthorized]) => {
        if (serviceRequiresConsents && !serviceIsAuthorized) return true;

        return router.parseUrl(`${FeaturesRoutingEnum.Redirect}/${serviceId}`);
      })
    );
  }
};
